import * as MY_RECEIPTS_ACTIONS from "./actionTypes";

export function getMyReceiptsPageRecords(data): any {
    return {
        payload: data,
        type: MY_RECEIPTS_ACTIONS.MY_RECEIPTS_PAGE_RECORDS,
    };
}
